<template>
  <div class="loginadmin loginBox login_bg">
    <!--<LazyScript src="http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js" @onload="onload"></LazyScript>-->
    <div class="headBox"></div>
    <div class="formBox">
      <ul id="formUl" :style="{ width: isYanfa ? '378px' : '189px' }">
        <li @click="change" :class="{ active: flag == 1 }">
          {{ loginTitle1 }}
        </li>
        <li v-if="isYanfa" @click="change2" :class="{ active: flag == 2 }">
          {{ loginTitle2 }}
        </li>
      </ul>
      <!--<div v-show="flag==1" class="height100">-->
      <!--<div class="erweima height100">-->
      <!--<div class="erweima-top height100" id="erweima-top">-->
      <iframe
        style="width: 100%;height: 100%"
        :src="loginCodeUrl"
        frameborder="0"
        scrolling="no"
        sandbox="allow-scripts allow-top-navigation  allow-same-origin"
        v-show="flag == 1"
      ></iframe>
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->

      <div v-show="flag == 2">
        <!--暂时注释-->
        <!-- <div class="verBox" style="position: relative" :class="{a:!isPhone && isvalidatePhone}">
          <input v-model="loginIfon.phoneNumber" placeholder="请输入手机号" @blur="validatePhone">
        </div>
        <p v-if="!isPhone && isvalidatePhone" style="color:#ff8a00;margin: 10px 0 10px 10px;">手机号不正确</p>
        <div class="sliderBox" :style="{background: bg,color:color}">
          <div id="slider" @mousedown="slideVerification" :style="{ left: ii + 'px'}"></div>
          {{con}}
        </div>
        <div class="phoneCode">
          <input type="text" placeholder="请输入手机验证码" v-model="loginIfon.phoneCode">
          <button @click="getValidCode" v-if="isDisabled">发送验证码</button>
          <button v-else disabled>{{countdown}}s</button>
        </div>-->
        <!--暂时放开-->
        <div class="box" style="width:378px">
          <div class="title box">手机号</div>
          <div
            class="verBox box_f1"
            style="position: relative"
            :class="{ a: !isPhone && isvalidatePhone }"
          >
            <input
              v-model="loginIfon.phoneNumber"
              placeholder="请输入手机号"
              @blur="validatePhone"
              style="width:98%"
            />
          </div>
        </div>
        <p
          v-if="!isPhone && isvalidatePhone"
          style="color:#ff8a00;margin: 10px 0 10px 10px;"
        >
          手机号不正确
        </p>
        <div class="box" style="width:378px">
          <div class="title box">验证码</div>
          <div
            class="verBox box_f1 box"
            style="position: relative"
            :class="{ a: !isPhone && isvalidatePhone }"
          >
            <input
              type="text"
              class="box_f1"
              placeholder="请输入密码"
              v-model="loginIfon.phoneCode"
            />
            <Button
              @click="getValidCode"
              v-if="isDisabled"
              type="primary"
              class="randomBtn box"
              >发送验证码</Button
            >
            <Button v-else disabled class="box">{{ countdown }}s</Button>
          </div>
        </div>
        <!--  <button class="clickLogin" @click="send">登录</button> -->
        <Button
          type="primary"
          size="small"
          class="clickLogin bc-color"
          :loading="msg"
          @click="send"
        >
          <span v-if="!msg">登录</span>
          <span v-else>登录</span>
        </Button>
        <!-- <div class="formFoot"><a href="javascript:;">企业加盟</a></div> -->
      </div>
    </div>

    <!-- <div>
      <div style="font-size: 16px">最新通知</div>

      <div
        class="notice box"
        v-for="(item, index) in noticeList"
        :key="index"
        @click="goDetail(index)"
      >
        <img :src="item.pic" class="not-pic box" alt v-if="item.pic" />
        <div class="box_f1" style="overflow: hidden">
          <div class="n-tit slh">{{item.title}}</div>
          <div class="n-tim">{{item.time}}</div>
        </div>
      </div>
    </div> -->

    <div class="footer">
      <div class="box" style="justify-content: center">
        <div>市委组织部 市委营商环境办</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  data: function() {
    return {
      isYanfa: false, //判断是否是研发环境打开的
      aaa: "1111",
      loginTitle1: "二维码登录",
      loginTitle2: "账号登录",
      //      erweimaSrc:'https://open.weixin.qq.com/connect/qrcode/051eN8vgqTW8Bw8o',
      weixin: "微信",
      // 15501272356
      loginIfon: {
        phoneNumber: "",
        phoneCode: ""
      },
      isvalidatePhone: false,
      isPhone: false,
      isDisabled: true,
      countdown: 60,
      flag: 1,
      con: "请按住滑块，拖动到最右边",
      ii: 0,
      bg: "#e8e8e8",
      color: "#9c9c9c",
      slideFlag: false,
      isSlide: false,
      loginCodeUrl: "",
      banben: "01.01.0003",
      noticeList: []
    };
  },
  components: {},
  props: ["msg"],
  created: function() {
    var vm = this;
    var appid = "";
    var redirect_uri = "";
    if (
      window.location.host.indexOf("yanfa") > -1 ||
      window.location.host.indexOf("localhost") > -1 ||
      window.location.host.indexOf("192.168.") > -1 ||
      window.location.host.indexOf("ceshi") > -1 ||
      window.location.host.indexOf("py.shequyun") > -1 ||
      window.location.host.indexOf("wxapp.ipuyang") > -1
    ) {
      this.isYanfa = true;
    }

    //var url = this.$store.state.serverHost + 'uc/api/user/getQrParam'
    // this.$http
    //   .get(url, {})
    //   .then(function (response) {
    //     console.log(response)
    //     appid = response.data.newPrimaryKeys.appid
    //     redirect_uri = encodeURIComponent(response.data.newPrimaryKeys.serverUrl)
    //     vm.loginCodeUrl = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + appid + '&scope=snsapi_login&redirect_uri=' + redirect_uri + '&login_type=jssdk&self_redirect=default&href=https://shequ.bkcc.com.cn/wx.css&state='
    //     console.log(vm.loginCodeUrl)
    //   })
    //   .catch(function (error) {
    //     console.log(error)
    //   })
    /* 获取二维码 */
    this.$get(this.urlobj.getQrParam,{
      domain:window.location.host
    })
      .then(resp => {
        appid = resp.newPrimaryKeys.appid;
        redirect_uri = encodeURIComponent(
          resp.newPrimaryKeys.serverUrl + "/#/NewLogin"
        );
        let href = "https://shequyun.cn/wx.css";
        vm.loginCodeUrl =
          "https://open.weixin.qq.com/connect/qrconnect?appid=" +
          appid +
          "&scope=snsapi_login&redirect_uri=" +
          redirect_uri +
          "&login_type=jssdk&self_redirect=default&href=" +
          href +
          "&state=2";
        if (this.$store.state.isTV == 1) {
          href = "https://shequyun.cn/wx_android.css";
          redirect_uri = encodeURIComponent(
            resp.newPrimaryKeys.serverUrl + "/#/NewLogin"
          );
          vm.loginCodeUrl =
            "https://open.weixin.qq.com/connect/qrconnect?appid=" +
            appid +
            "&scope=snsapi_login&redirect_uri=" +
            redirect_uri +
            "&login_type=jssdk&self_redirect=default&href=" +
            href +
            "&state=1";
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    onload: function() {
      var obj = new WxLogin({
        id: "erweima-top",
        appid: "wx28ab84dd9eb86b69",
        scope: "snsapi_login",
        redirect_uri: "http%3a%2f%2fshequ.vitoyun.cn",
        state: "",
        style: "",
        //href: 'https://hanguang90.github.io/weixin.css'
        href: "https://sunyudi.github.io/wx/wx.css"
      });
    },
    send: function() {
      if (this.isPhone && this.loginIfon.phoneCode) {
        this.$emit("event", this.loginIfon);
      } else {
        this.$Message.error("请填写正确的手机号和验证码!");
      }
    },
    validatePhone: function() {
      this.isvalidatePhone = true;
      // var reg = /^1[3|4|5|7|8][0-9]{9}$/;
      var reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
      this.isPhone = reg.test(this.loginIfon.phoneNumber);
    },
    change: function() {
      this.flag = 1;
    },
    change2: function() {
      this.flag = 2;
    },
    slideVerification: function(e) {
      if (this.slideFlag) return;
      var bb = e.clientX;
      var vm = this;
      document.onmousemove = function(e) {
        var dd = e.clientX;
        if (dd - bb > 0) {
          vm.ii = dd - bb;
        } else {
          vm.ii = 0;
          return;
        }
        if (vm.ii >= 330) {
          vm.ii = 330;
          vm.bg = "#7ac23c";
          vm.color = "#fff";
          vm.con = "验证通过";
          document.onmousemove = null;
          vm.slideFlag = true;
        }
      };
      document.onmouseup = function() {
        document.onmousemove = null;
        if (vm.ii >= 330) {
          vm.ii = 330;
        } else {
          vm.ii = 0;
        }
      };
    },
    getValidCode: function() {
      if (this.isPhone) {
        //if (this.slideFlag && this.isPhone) {
        this.isDisabled = false;

        this.$get(this.urlobj.sendRandomByPhone, {
          phone: this.loginIfon.phoneNumber
        })
          .then(resp => {
            this.setTime();
            console.log(resp);
          })
          .catch(error => {
            this.isDisabled = true;
            console.log(error);
          });
      } else {
        this.$Message.error("请填写正确的手机号!");
      }
    },
    setTime: function() {
      if (this.countdown == 0) {
        this.isDisabled = true;
        this.countdown = 60;
      } else {
        this.countdown--;
        var vm = this;
        setTimeout(function() {
          vm.setTime();
        }, 1000);
      }
    },
    getNoticeList() {
      // this.loading = true;
      this.$get(this.urlobj.getSysNotice)
        .then(res => {
          let list = res.rows.map(item => {
            return {
              title: item.title,
              id: item.id,
              time: item.createTime.substring(0, 10),
              pic: item.coverPicUrl,
              isRead: item.isRead
            };
          });
          console.log(list);
          this.noticeList = list;
          // this.loading = false;
        })
        .catch(e => {
          // this.loading = false;
        });
    },
    goDetail(index) {
      this.$router.push({
        name: "sysNotDetail",
        query: { id: this.noticeList[index].id, from: "NewLogin" }
      });
    }
  },
  mounted() {
    this.getNoticeList();
  },
  computed: {
    isPy() {
      console.log(location.host.includes("py.shequyun.cn"));
      return location.host.includes("py.shequyun.cn");
    }
  }
};
</script>
<style>
.impowerBox .title {
  display: none !important;
}
.impowerBox .qrcode {
  width: 200px !important;
}
</style>
<style scoped>
.login_bg {
  background: url("../../../assets/images/pyChiefWaiterManageLogin/py_chief_waiter_manage_login_bg.png")
    no-repeat center center / cover;
}
.height100 {
  height: 100%;
}
.a {
  border: 1px solid #ff8a00 !important;
}
.loginBox {
  background-color: #fff;
  width: 100%;
  height: 100%;
  /* position: relative; */
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  padding-bottom: 100px;
}
/*账号密码登录*/
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.headBox {
  height: 200px;
  /*height: 185px;*/
  width: 660px;
  background: url("../../../assets/images/pyChiefWaiterManageLogin/py_chief_waiter_manage_login_title.png")
    no-repeat center center / contain;
}
.headBox1 {
  height: 200px;
  width: 660px;
  background: url("../../../assets/images/ipy.png") no-repeat 100px center;
}
.formBox {
  /*width: 380px;*/
  /*width: 300px;*/
  /*height: 300px;*/
  margin: 0 auto;
  flex: 1;
  height: 350px;
}
.formBox #formUl {
  font-size: 14px;
  /*width: 378px;*/
  /* width: 189px; */
  height: 28px;
  line-height: 28px;
  /*border-bottom: 1px solid #e4e4e4;*/
  cursor: pointer;
  position: relative;
  margin: auto;
}
.formBox #formUl li {
  text-align: center;
  width: 189px;
  float: left;
  margin-bottom: 2px;
}
.active {
  border-bottom: 2px solid #ff7b44;
}
#formUl::after {
  content: "";
  display: block;
  /*width: 378px;*/
  width: 189px;
  height: 1px;
  background-color: #e4e4e4;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.verBox {
  width: 100%;
  height: 42px;
  margin: 24px auto 0;
  border: 1px solid #d7dde4;
  border-radius: 5px;
}
.verBox input {
  height: 40px;
  float: left;
  border: none;
  outline: none;
  margin-left: 6px;
  color: #333333;
}
.phoneCode {
  width: 100%;
  height: 42px;
  margin: 10px auto 0;
}
.phoneCode input {
  width: 260px;
  height: 40px;
  float: left;
  outline: none;
  padding-left: 6px;
  border: 1px solid #d7dde4;
  border-radius: 5px;
  color: #333333;
}
.phoneCode button {
  float: right;
  width: 105px;
  height: 40px;
  background: none;
  outline: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  line-height: 40px;
  color: #575656;
  cursor: pointer;
}

.verBox button {
  width: 105px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  margin-left: 20px;
}

.sliderBox {
  width: 100%;
  height: 40px;
  line-height: 38px;
  font-size: 12px;
  margin: 10px auto 0;
  /*margin: 25px auto 0;*/
  border-radius: 5px;
  position: relative;
  text-align: center;
  background: rgb(232, 232, 232);
  color: rgb(156, 156, 156);
}
.sliderBox::selection {
  background-color: transparent;
}
#slider {
  width: 50px;
  height: 40px;
  text-align: center;
  border-radius: 5px;
  background: url("../../../assets/images/slider.png") no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}
.clickLogin {
  width: 100%;
  height: 42px;
  /*background: none;*/
  outline: none;
  border: none;
  border-radius: 5px;
  /*background-color: #3c7ce6;*/
  margin: 35px auto 0;
  color: #fff;
  cursor: pointer;
}
.formFoot {
  width: 100%;
  height: 42px;
  margin: 25px auto 0;
  line-height: 42px;
  text-align: center;
}
.formFoot a {
  color: #333333;
}
/*二维码登录*/
.erweima-top {
  /*width: 380px;*/
  width: 100%;
  margin-top: 30px;
  text-align: center;
  /*transform: translateX(-25%);*/
}
.erweima-top img {
  width: 234px;
  height: 234px;
}
/*.erweima-bottom {*/
/*position: relative;*/
/*text-align: center;*/
/*padding-left: 20px;*/
/*}*/
/*.erweima-bottom a {*/
/*font-size: 14px;*/
/*}*/
/*.erweima-bottom .sys {*/
/*width: 40px;*/
/*height: 40px;*/
/*position: absolute;*/
/*top: 0;*/
/*left: 100px;*/
/*background: url("../assets/images/sys.png") no-repeat;*/
/*}*/

/*.erweima-bottom span {*/
/*color: #666666;*/
/*font-weight: 700;*/
/*font-size: 14px;*/
/*}*/
.footer {
}
.footer .box {
  font-size: 20px;
}
.footerBox {
  /*position: absolute;*/
  /*bottom:20px;*/
  /*left:60px;*/
}
.foot-logo {
  text-align: center;
}
.href {
  text-decoration: underline;
  color: #ff7b44;
}
.shu {
  border-left: 1px solid #666;
  margin: 0 20px;
}
.notice {
  padding: 20px;
  border: 1px solid #e1e1e1;
  margin: 20px 0;
  width: 500px;
}
.not-pic {
  width: 152px;
  height: 102px;
  margin-right: 20px;
}
.n-tit {
  font-size: 22px;
  color: #4b4b4b;
}
.n-tim {
  font-size: 16px;
  color: #999;
  margin-top: 30px;
}

.title {
  margin-right: 20px;
  margin-top: 24px;
  line-height: 42px;
}
</style>
